export default __webpack_public_path__ + "static/media/2257.6935df14.png";